// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"15e9bbe3","703":"86cc52ba","760":"4f056767","787":"319095bc"}[chunkId] + ".chunk.js";
};